export const SET_OFFERS = 'set-offers';
export const REFETCH_OFFERS = 'refetch-offers';
export const SET_MEMBERSHIP = 'set-membership';
export const REFETCH_MEMBERSHIP = 'refetch-membership';
// export const SET_SELECTED_CUSTOMER = 'set-selected-customer';
// export const CLEAR_SELECTED_CUSTOMER = 'clear-selected-customer';
